import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stockPage"},[_c('StockPageHeader'),_c(VTabs,{attrs:{"vertical":_vm.verticalTabs}},[_c(VTab,{staticClass:"flex-start"},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-finance")]),_vm._v(" "+_vm._s(_vm.$t('stockPage.tabs.quote'))+" ")],1),_c(VTab,{staticClass:"flex-start",on:{"click":_vm.loadAiAnalysis}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-memory")]),_vm._v(" "+_vm._s(_vm.$t('stockPage.tabs.ai_analysis'))+" ")],1),_c(VTabItem,[_c('StockQuote')],1),_c(VTabItem,[_c('StockAiAnalysis')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }